import React, { useEffect, useState } from "react";
import { Accordion, Button, Col, Container, FormControl, Row } from "react-bootstrap";
import logo from "../../white-logo.png";
import PrivateApi from "../../services/PrivateApiService";
import { useQuery } from "react-query";
import SplashPage from "../SplashPage";
import AccordionItem from "react-bootstrap/esm/AccordionItem";
import AccordionHeader from "react-bootstrap/esm/AccordionHeader";
import AccordionBody from "react-bootstrap/esm/AccordionBody";
import { useAuthState } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";

const FaqPage = () => {

    const { user } = useAuthState();
    const target = user.x_is_house_management ? 'HW':"PRI";
    const API = new PrivateApi();
    const navigate = useNavigate();

    const [selectedTopic, setSeletectedTopic] = useState({});
    const [searchField, setSearchField] = useState("");
    const [searchShow, setSearchShow] = useState(false);
    const [searchData, setSearchData] = useState([]);


    const { data, error, isLoading } = useQuery(
        ['GET_FAQ_QUERY', target],
        () => API.get_faq(target),
        {staleTime: Infinity}
    )


    useEffect(() => {
        if (data && data.data.length > 0) {
            setSeletectedTopic(data.data[0]);
        }
    }, [data])


    useEffect(() => {
        setSearchData([]);
        if (searchField.length > 3) {
            setSearchShow(true);
            var splitedArr = searchField.split(" ");
            var tmp = [];
            splitedArr.forEach(word => {
                if (word !== "") {
                    data.data.forEach(d => {
                        d.faqqa_set.forEach(qa => {
                            if (
                                (qa.question.toLowerCase().includes(word.toLowerCase()) ||
                                qa.answer.toLowerCase().includes(word.toLowerCase())) &&
                                !tmp.includes(qa)
                            ) {
                                tmp.push(qa);
                            }
                        });
                    });
                }
            });
            setSearchData(tmp);
        } else {
            setSearchShow(false);
        }
    }, [searchField])


    if (error) return <SplashPage error={error} />
    if (isLoading) return <SplashPage />


    const toNewTicket = () => {
        if (user.x_is_house_management) {
            navigate('/hw/dashboard/support/neu/');

        } else {
            navigate('/dashboard/support/neu');
        }
    }

    return (
        <>
            <div className="bg-dark text-light" style={{ 
                    marginTop: "-70px", 
                    paddingTop: "70px", 
                    paddingBottom: "40px", 
                    paddingLeft: "10%", 
                    paddingRight: "10%" 
                }}>
                <Container>
                    <Row className="align-items-center">
                        <Col xs="12" md="6" xl="6">
                            <h2><b className="text-energo">ENERGO</b> FAQs</h2>
                            <p>
                                Auf dieser Seite finden Sie eine Sammlung von häufig gestellten Fragen (FAQ).
                                Hier beantworten wir die wichtigsten Fragen unserer Kunden, um Ihnen schnell
                                und unkompliziert weiterzuhelfen. Schauen Sie hier nach, um Antworten auf
                                Ihre Fragen zu erhalten, ohne den Kundensupport kontaktieren zu müssen.
                            </p>
                        </Col>
                        <Col xs="12" md="6" xl="6" className="text-center">
                            <img src={logo} alt="" className="img-fluid" style={{maxWidth: "300px"}} />
                        </Col>
                    </Row>
                    <Row style={{marginTop: 50}} className="justify-content-center">
                        <Col xs="12" md="8" xl="4" className="text-center">
                            <FormControl 
                                type="search" 
                                placeholder="Suche" 
                                className="rounded-pill" 
                                value={searchField}
                                onChange={e => setSearchField(e.target.value)}
                            />
                        </Col>
                    </Row>
                </Container>
            </div>
            <Container>
                <Row className="bg-energo support-info-container">
                    <Col xs="12" md="12" xl="12" className="text-center">
                        <b>Im dem Fall, dass Sie Ihre Frage hier nicht beantwortet finden, können Sie uns direkt über unseren Support kontaktieren.</b> &nbsp;
                        <Button onClick={() => toNewTicket()} variant="warning" className="rounded-pill">Neues Ticket öffnen</Button>
                    </Col>
                </Row>
                <Row className="justify-content-center" style={{marginTop: 70}}>
                    <Col xs="12" md="4" xl="3" hidden={searchShow}>
                        <h5>Themen</h5>
                        <ul>
                            {data.data && data.data.length > 0?
                                data.data.map(topic =>
                                    <li key={`topic-${topic.id}`}>
                                        {topic === selectedTopic ?
                                            <b className="text-energo">{topic.name}</b> :
                                            <a 
                                                onClick={e => {e.preventDefault(); setSeletectedTopic(topic)}}
                                                href={`/${topic.name }`} 
                                                className="link-energo text-dark"
                                            >
                                                {topic.name}
                                            </a>
                                        }
                                    </li>    
                                )
                            :null}
                        </ul>
                    </Col>
                    <Col xs="12" md="8" xl="9" hidden={searchShow}>
                        {selectedTopic && selectedTopic.faqqa_set !== undefined?
                            <>
                                <h4 className="text-center mb-4">{selectedTopic.name}</h4>
                                {selectedTopic.faqqa_set.length > 0?
                                    <Accordion>
                                        {selectedTopic.faqqa_set.map(qa => 
                                            <AccordionItem key={`qa-${qa.id}`} eventKey={qa.id}>
                                                <AccordionHeader>{qa.question}</AccordionHeader>
                                                <AccordionBody dangerouslySetInnerHTML={{ __html: qa.answer}}></AccordionBody>
                                            </AccordionItem>
                                        )}
                                    </Accordion>
                                :null}
                            </>
                        :null}
                    </Col>
                    <Col xl="8" hidden={!searchShow}>
                        <h4 className="text-center mb-4">Suche</h4>
                        <Accordion>
                            {searchData && searchData.length > 0?
                                searchData.map(qa => 
                                    <AccordionItem key={qa.id} eventKey={qa.id}>
                                        <AccordionHeader>{qa.question}</AccordionHeader>
                                        <AccordionBody dangerouslySetInnerHTML={{ __html: qa.answer}}></AccordionBody>
                                    </AccordionItem>
                                ) :
                                <p className="text-center">Keine Frage/Antwort gefunden.</p>
                            }
                        </Accordion>
                    </Col>
                </Row>
            </Container>
        </>
    )
}
export default FaqPage;